import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
 createProduct,
 getProducts,
 updateProduct,
 getSingleProduct,
} from "../Api/ApiCalls";
import LoadingSpinner from "../common/Loading";
import { productValidationSchema } from "../common/Validation";
import log from "../core/log";
import { useLocation } from "react-router-dom";

export const CreateProduct = () => {
 const formOptions = { resolver: yupResolver(productValidationSchema) };
 const [loading, setLoading] = useState(false);
 const [products, setProducts] = useState([]);
 const [productData, setProductData] = useState([]);
 const location = useLocation();
 const [toasting, setToasting] = useState(false);
 const { id } = location.state || "";

 const {
  register,
  handleSubmit,
  formState: { errors },
  reset,
 } = useForm(formOptions);

 const onSubmit = async (data) => {
  setLoading(true);
  if (!productData) {
   try {
    const result = await createProduct(data);
    if (result.status) {
     toast.success("Product created successfully");
     resetFields(data);
     manipulatePro(data, "ADD");
    } else {
     toast.info("Product with this SKU exist");
     reset({ sku: "" });
    }
    setLoading(false);
   } catch (err) {
    console.log(err);
    log("Error while creating product data ", err);
    setLoading(false);
   }
  } else {
   try {
    delete data.id;
    await updateProduct({
     id: productData.id,
     payload: data,
    });

    toast.success("Product Updated successfully", {
     toastId: "update",
     onClose: () => {
      setToasting(false);
     },
     onOpen: () => {
      setToasting(true);
     },
    });
    manipulatePro(
     {
      id: productData.id,
      ...data,
     },
     "UPDATE"
    );
    setLoading(false);
   } catch (err) {
    console.log(err);
    log("Error while updating product data ", err);
    setLoading(false);
   }
  }
 };

 const resetFields = (data) => {
  if (!data || !Object.keys(data).length) return;
  const tempObj = {};
  Object.keys(data).forEach((field) => {
   tempObj[field] = "";
  });
  reset(tempObj);
 };

 const getAllOrganization = async () => {
  try {
   setLoading(true);
   const data = await getProducts();
   if (data) {
    setProducts(data);
   }
   setLoading(false);
  } catch (err) {
   log(`Error while fetching products: `, err);
   setLoading(false);
  }
 };
 const manipulatePro = (data, method) => {
  if (!data || !method) return;
  setLoading(true);
  const tempProData = [...products];
  if (method === "ADD") {
   tempProData.push(data);
  } else if (method === "UPDATE") {
   const index = tempProData.findIndex((pro) => pro?.id === data?.id);
   if (index !== -1) tempProData[index] = data;
  } else if (method === "DELETE") {
   const index = tempProData.findIndex((pro) => pro?.id === data?.id);
   if (index !== -1) tempProData.splice(index, 1);
  }
  setProducts(tempProData);
  setLoading(false);
 };

 const getProductData = async () => {
  setLoading(true);
  try {
   const result = await getSingleProduct(id);
   if (result.status) {
    setProductData(result.data);
    reset(result.data);
   } else {
    toast.info(result.message);
   }
   setLoading(false);
  } catch (err) {
   console.log(err);
   log("Error while fetching organization data ", err);
   setLoading(false);
  }
 };

 useEffect(() => {
  getAllOrganization();
 }, []);

 useEffect(() => {
  if (id) {
   getProductData();
  } else {
   resetFields(productData);
   setProductData();
  }
 }, [location]);

 return (
  <>
   <div className="grid grid-rows-1">
    <div className="flex overnpmflow-hidden">
     <div className="content relative flex-1 pb-10">
      <form onSubmit={handleSubmit(onSubmit)}>
       <h2 className="text-4xl text-[#96BF61] font-bold">
        {id ? "Edit Product" : "Create Product"}
       </h2>

       {loading && <LoadingSpinner />}
       <div className="grid grid-cols-12 mt-5">
        <div className="col-span-12 lg:col-span-12">
         <div className=" shadow-md rounded">
          <div className="bg-white rounded-[21px] p-10 mt-6">
           <div className="">
            <div className="flex flex-col sm:flex-row items-center">
             <div className="flex-auto w-1/4 relative">
              <span className="text-red-600 top-0 absolute my-4 block">
               {errors?.sku?.message}
              </span>
              <label
               htmlFor="sku"
               className="text-black font-semibold text-sm mb-4 block"
              >
               SKU
               <span className="text-red-600">*</span>
              </label>
              <input
               id="sku"
               {...register("sku", {
                required: true,
               })}
               className={`py-3 block shadow-md px-4 mt-0  ${
                productData ? "bg-gray-300" : "bg-transparent"
               } border border-b-2 appearance-none w-full focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
               disabled={productData}
               placeholder="Enter SKU"
              />
             </div>
             <div className="flex-auto w-1/4 mx-2 relative">
              <span className="text-red-600 top-0 absolute my-4 block">
               {errors?.product_name?.message}
              </span>
              <label
               htmlFor="product_name"
               className="text-black font-semibold text-sm mb-4 block"
              >
               Product Name
               <span className="text-red-600">*</span>
              </label>
              <input
               id="product_name"
               type="text"
               {...register("product_name", {
                required: true,
               })}
               className="py-3 shadow-md block w-full px-4 mt-0 bg-transparent border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
               placeholder="Enter Product Name"
              />
             </div>
             <div className="flex-auto w-1/4 mx-2 relative">
              <span className="text-red-600 top-0 absolute my-4 block">
               {errors?.expiry?.message}
              </span>
              <label
               htmlFor="expiry"
               className="text-black font-semibold text-sm mb-4 block"
              >
               Expiry in Days
               <span className="text-red-600">*</span>
              </label>
              <input
               id="product_name"
               type="text"
               {...register("expiry", {
                required: true,
               })}
               className="py-3 shadow-md block w-full px-4 bg-transparent border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
               placeholder="Enter No of Days"
              />
             </div>
             <div className="flex-auto w-1/4 relative">
              <span className="text-red-600 top-0 absolute my-4 block">
               {errors.product_status?.message}
              </span>
              <label
               htmlFor="expiry"
               className="text-black font-semibold text-sm mb-4 block"
              >
               Status
               <span className="text-red-600">*</span>
              </label>
              <>
               <select
                {...register("product_status")}
                className="py-3 shadow-md w-full block px-4 mt-0 bg-white border border-b-2 z-1 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md "
               >
                <option value="">Select status</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
               </select>
               <div className="absolute right-2 top-[52px] pointer-events-none">
                <svg width="20" height="20" viewBox="0 0 24 24">
                 <path
                  d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                  fill="#1D192B"
                 ></path>
                </svg>
               </div>
              </>
             </div>
            </div>
            <div className="pt-12 text-right">
             <button
              disabled={toasting}
              type="form"
              className="px-4 py-2 text-lg text-white transition-all duration-150 ease-linear rounded-md shadow outline-none font-semibold bg-[#024C85] hover:bg-[#134d86] hover:shadow-lg focus:outline-none"
             >
              {productData ? "Update Product" : "Add Product"}
             </button>
            </div>
           </div>
          </div>
         </div>
        </div>
       </div>
      </form>
     </div>
    </div>
   </div>
  </>
 );
};
